import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices'
import N from 'utils/navigation'
import { useFindGMSWithNonOption, useGetExternalGMS, useUpdateExternalGMS } from 'app/auth/components/hooks/use-external-gms'

export const CaptureGMSFormCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()
  const externalGMSQueryResult = useGetExternalGMS()
  const updateExternalGMS = useUpdateExternalGMS()
  const externalGMSNonOption = useFindGMSWithNonOption(externalGMSQueryResult.data || [])

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <ElectricalServicesIcon />,
        content: t('SetupWizard.CaptureExternalGMSSummary'),
        buttonText: t('SetupWizard.CaptureExternalGMSCTA'),
        actionOnClick: () => {
          N.push('/settings/capture-external-gms')
        },
        skipAction:
          externalGMSNonOption &&
          (async () => {
            await updateExternalGMS.mutateAsync({
              ExternalGMSUUID: externalGMSNonOption?.UUID || '',
              Remark: externalGMSNonOption?.Name || ''
            })
            props.refetch()
          })
      }}
    />
  )
}
